module.exports = __webpack_public_path__ + "static/media/piloto.f29b122f.png";